export const FeatureFlag = {
  RedirectToAppCdt: 'enabledRedirectToAppCdt',
} as const

export const LAUNCHDARKLY_INIT_TIMEOUT_SECONDS = 2
